export default __webpack_public_path__ + "static/gearsOfWar-6cdc657601dce162233c0aab07966738.jpg";